<template lang="pug">
div
  label Roles
  md-select(:multiple='false' v-model='selected[0]', @selected='onSelected', :disabled="isBaseUser()")
    md-option(v-if="isAdmin()", value="Admin") Admin
    md-option(v-for='role in roles', :value='role.key' :key='role.key') {{ role.value }}
</template>

<script>
  import { roles } from '../../assets/data/roles/index';
  import { mapState } from 'vuex';

  export default {
    props: {
      value: {
        type: [String, Array],
        required: true
      }
    },
    data() {
      return {
        selected: this.value,
        roles
      };
    },

    computed: {
      ...mapState({
        siteuser: state => state.user.siteuser
      })
    },

    methods: {

      isAdmin() {

        // Check user has 'authorization' and Check user has 'roles'
        if (this.siteuser.authorization && this.siteuser.authorization.roles) {
          return this.siteuser.authorization.roles.includes('Admin');
        }

        return false;
      },

      isAccountAdmin() {

        // Check user has 'authorization' and Check user has 'roles'
        if (this.siteuser.authorization && this.siteuser.authorization.roles) {
          return this.siteuser.authorization.roles.includes('AccountAdmin');
        }

        return false;
      },

      onSelected(value) {
        this.$emit('input', [value]);
      },

      isBaseUser() {
        return !this.isAdmin() && !this.isAccountAdmin();
      },
    },
    watch: {
      value(newValue) {
        if (newValue) {
          this.selected = newValue;
        }
      }
    },
  };
</script>
<style scoped>
.md-input-disabled .md-select:not(.md-select-icon):after {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/shared-components/user/UserRolesSelector.vue